import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharesComponent } from './shares.component';
import { StaticMsgModule } from '@lib/pipes';
import { TextTooltipModule } from '@lib/components';
import { EmailModalModule } from './email-modal/email-modal.module';
import { TooltipDirectiveModule } from '@lib/directives';

@NgModule({
  declarations: [SharesComponent],
  imports: [CommonModule, StaticMsgModule, TextTooltipModule, EmailModalModule, TooltipDirectiveModule],
  exports: [SharesComponent],
})
export class SharesModule {}
